var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "analytics_1_",
    "data-name": "analytics (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.366,
    height: 23.366,
    viewBox: "0 0 23.366 23.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(0 7.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M22.879,185.27h-.487V171.153a.487.487,0,0,0-.487-.487H18.985a.487.487,0,0,0-.487.487V185.27H16.551v-8.275a.487.487,0,0,0-.487-.487H13.143a.487.487,0,0,0-.487.487v8.275H10.709V175.047a.487.487,0,0,0-.487-.487H7.3a.487.487,0,0,0-.487.487V185.27H4.868v-5.355a.487.487,0,0,0-.487-.487H1.46a.487.487,0,0,0-.487.487v5.355H.487a.487.487,0,0,0,0,.974H22.879a.487.487,0,1,0,0-.974Z",
    transform: "translate(0 -170.666)",
    fill: "#f8333d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(0.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M40.8,0a1.935,1.935,0,0,0-1.672,2.93L35.946,6.117a1.911,1.911,0,0,0-2.49.454l-2.392-.682c0-.016,0-.03,0-.047a1.947,1.947,0,1,0-3.894,0,1.924,1.924,0,0,0,.172.792L24.3,9.061a1.92,1.92,0,0,0-1.024-.3,1.947,1.947,0,1,0,1.947,1.947,1.92,1.92,0,0,0-.252-.939l2.982-2.378a1.923,1.923,0,0,0,2.836-.569l2.256.644a1.844,1.844,0,0,0-.033.321,1.947,1.947,0,1,0,3.619-.983l3.187-3.187a1.919,1.919,0,0,0,.982.277A1.947,1.947,0,0,0,40.8,0Z",
    transform: "translate(-21.333)",
    fill: "#f8333d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.40069800914ade3fa65154725412fa78.svg";
export { ForwardRef as ReactComponent };